import { forwardRef } from 'react';

import { useThemeIcon } from '../icon/useThemeIcon';

import { ActionIconStyles } from './action-icon.styled';
import { IActionIconProps } from './types';

/**
 * An icon button that responds to user interactions,
 * for use inside other components like the TextInput
 */
const ActionIcon = forwardRef<HTMLButtonElement, IActionIconProps>(function ActionIcon(
  {
    title,
    type = 'button',
    icon,
    emphasize = false,
    onClick,
    disabled,
    'data-testid': testId,
    'aria-label': ariaLabel,
    className,
  },
  forwardedRef,
) {
  const Icon = useThemeIcon(icon);
  if (!Icon) {
    if (process.env.NODE_ENV === 'development') {
      throw new Error(`Icon with name "${icon}" not found. This makes the ActionIcon unusable.`);
    }
    return null;
  }

  return (
    <ActionIconStyles
      data-testid={testId}
      type={type}
      title={title}
      aria-label={ariaLabel}
      $emphasize={emphasize}
      onClick={onClick}
      disabled={disabled}
      ref={forwardedRef}
      className={className}
    >
      <Icon aria-hidden focusable="false" />
    </ActionIconStyles>
  );
});

export default ActionIcon;
